import React, { useEffect, useState } from 'react'
import AppIcon from '../common/AppIcon'
import { TextInput } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import AppInputWrapper from './AppInputWrapper'
import { useDebouncedCallback } from '@mantine/hooks'

interface CustomProps
  extends Omit<React.ComponentPropsWithoutRef<typeof TextInput>, 'onChange'> {
  w?: string | number
  entity?: string
  name?: string
  value?: string | null
  onChange?: any
  leftSection?: React.ReactNode
  label?: string
  labelh?: string
  placeholder?: string
  type?: 'text' | 'number'
  debounced?: boolean
}

const AppInput = ({
  w = '100%',
  entity,
  name,
  value,
  onChange,
  leftSection,
  label,
  labelh,
  placeholder,
  type = 'text',
  debounced = true,
  ...otherProps
}: CustomProps) => {
  const { t } = useTranslation()

  const [localValue, setLocalValue] = useState(value || '')

  useEffect(() => {
    setLocalValue(value || '')
  }, [value])

  const debouncedOnChange = useDebouncedCallback(
    (v: string) => {
      onChange?.({ target: { name, value: v } })
    },
    300, // milisegundos de debounce
  )

  return (
    <AppInputWrapper w={w} label={label}>
      <TextInput
        {...otherProps}
        w="100%"
        label={label && t(label)}
        value={localValue}
        onChange={(e) => {
          setLocalValue(e.target.value)
          if (onChange) {
            if (debounced) debouncedOnChange(e.target.value)
            else onChange(e.target.value)
          }
        }}
        leftSectionPointerEvents="none"
        leftSection={
          entity ? <AppIcon icon={entity} /> : <AppIcon icon="text" />
        }
        placeholder={placeholder && t(placeholder)}
      />
    </AppInputWrapper>
  )
}

export default AppInput
